const BASE_URL = process.env.REACT_APP_BASE_URL;
const FILE_UPLOAD = `${BASE_URL}/pba75001py_boc_files/files/services/files/file-upload`;
const BASE_AUTH_URL = `${BASE_URL}/tagitstore_auth`;
const BASE_USERS_URL = `${BASE_URL}/tagitstore_users`;
const BASE_SUBSCRIPTION_URL = `${BASE_URL}/tagitstore_subscription`;
const BASE_BUSINESS_URL = `${BASE_URL}/tagitstore_business`;
const BASE_MENU_URL = `${BASE_URL}/tagitstore_menu`;
const BASE_OFFER_URL = `${BASE_URL}/tagitstore_offer`;
const BASE_PRODUCT_URL = `${BASE_URL}/tagitstore_product`;
const BASE_ROLE_URL = `${BASE_URL}/tagitstore_role`;
const BASE_STATE_URL = `${BASE_URL}/tagitstore_lookup`;
const BASE_COUNTRY_URL = `${BASE_URL}/pba75001py_public/master/services/master/getall-countries`;
const BASE_BILLPREVIEW_EDIT = `${BASE_URL}/pba75001py_store_config`;

const GET_IMAGE = `${BASE_URL}/pba75001py_files`;

export const API_KEY = {
    AES_KEY: process.env.REACT_APP_AES_KEY,
    AES_IV: process.env.REACT_APP_AES_IV,
    RAZOR_KEY: process.env.REACT_APP_RAZOR_KEY,
    NAME: process.env.REACT_APP_NAME,
    EMAIL: process.env.REACT_APP_EMAIL,
    CONTACT: process.env.REACT_APP_CONTACT
};

export const API_URL = {
    SIGN_UP: `${BASE_AUTH_URL}/boc/register`,
    LOGIN: `${BASE_AUTH_URL}/boc/login`,
    LOGOUT: `${BASE_AUTH_URL}/user/logout/boc`,
    RESEND_24: `${BASE_AUTH_URL}/boc/resend/verification`,
    USER_DATA: `${BASE_AUTH_URL}/boc/login/change`,
    VALIDATE_TOKEN: `${BASE_AUTH_URL}/boc/verify/user`,
    CHANGE_PASSWORD: `${BASE_AUTH_URL}/resetpassword/boc`,
    SET_PASSWORD: `${BASE_AUTH_URL}/boc/register/verify`,
    FORGOT_PASSWORD: `${BASE_AUTH_URL}/forgotpassword/boc`,
    FORGOT_VERIFY: `${BASE_AUTH_URL}/forgotpassword/boc/verify`,
    REFRESH_TOKEN: `${BASE_AUTH_URL}/refreshToken/boc`,
    STATE: `${BASE_STATE_URL}/stateLookup`,
    BUSINESS_CREATE: `${BASE_BUSINESS_URL}/businessConfig`,
    COUNTRY_CODE: `${BASE_COUNTRY_URL}`,
    FILE_UPLOAD: `${FILE_UPLOAD}`,
    MANAGE_LICENSE: `${BASE_BUSINESS_URL}/businessLicense`,
    HEADER_IMAGE: `${BASE_BUSINESS_URL}/businessLicense/licenseimg`,
    GET_BUSINESSUUID: `${BASE_BUSINESS_URL}/businessConfig`,
    PLAN_BUSINESSNAME: `${BASE_BUSINESS_URL}/businessDetails`,
    PRODUCT: `${BASE_PRODUCT_URL}/product/boc`,
    PRICING: `${BASE_PRODUCT_URL}/productPlanPricing`,
    GET_LICENSEBUSINESSUUID: `${BASE_BUSINESS_URL}/businessLicense`,
    UPDATE_LICENSE: `${BASE_BUSINESS_URL}/businessLicense`,
    PUT_BUSINESSDETAILS: `${BASE_BUSINESS_URL}/businessConfig`,
    PLAN_FEATURES: `${BASE_PRODUCT_URL}/productPlanPricing/packages/features`,
    GET_ACTIVE_SUBSCRIPTION: `${BASE_SUBSCRIPTION_URL}/subscription/boc/user`,
    GET_ORDER_ID: `${BASE_SUBSCRIPTION_URL}/order/code`,
    DYNAMICMENU: `${BASE_MENU_URL}/menu`,
    USERBASEMANU: `${BASE_MENU_URL}/menu/boc/role`,
    USER: `${BASE_AUTH_URL}/boc/user/signup`,
    GETALLUSER: `${BASE_USERS_URL}/users/boc/user`,
    GETPARENTDETAILS: `${BASE_USERS_URL}/users/boc/user/organization/parentdetails`,
    GETALLUSERID: `${BASE_USERS_URL}/users/boc`,
    GETALLROLE: `${BASE_ROLE_URL}/role/boc`,
    ROLECHART: `${BASE_MENU_URL}/menu/boc/allrole`,
    BUSINESS_SELECTION: `${BASE_USERS_URL}/users/boc/user/organization`,
    USER_GET_ID: `${BASE_USERS_URL}/users/boc/role`,
    GETALL_MASTERROLE: `${BASE_USERS_URL}/usermapping/roles`,
    GETALL_USER: `${BASE_USERS_URL}/users/boc/user/all`,
    USER_IDENTITY: `${BASE_USERS_URL}/usermapping`,
    GET_ROLE_ACTIVITY: `${BASE_USERS_URL}/users/boc/user/roleactivity`,
    GET_EXPIRED_PRODUCTS: `${BASE_SUBSCRIPTION_URL}/subscription/user/expiring`,
    CREATE_SUBSCRIPTION: `${BASE_SUBSCRIPTION_URL}/subscription/order`,
    GETALL_USERMAPPING: `${BASE_USERS_URL}/usermapping/users`,
    USER_EDIT: `${BASE_USERS_URL}/usermapping/users`,
    SUBCRIPTIONBYID: `${BASE_SUBSCRIPTION_URL}/subscription/boc/user`,
    SPECIFIC_OFFER: `${BASE_OFFER_URL}/specificOffer/active`,
    GENERAL_OFFER: `${BASE_OFFER_URL}/generalOffer/active/boc`,
    FIND_SUBSCRIPTION: `${BASE_SUBSCRIPTION_URL}/subscription/user/active`,
    PAYMENT_VERIFY: `${BASE_SUBSCRIPTION_URL}/subscription/verifyPayment`,
    CANCEL_SUBSCRIPTION: `${BASE_SUBSCRIPTION_URL}/subscription/cancel`,
    INVOICE_PDF: `${BASE_SUBSCRIPTION_URL}/subscription/invoice/boc`,
    MENU_CREATED: `${BASE_ROLE_URL}/role/boc`,
    USER_GET: `${BASE_USERS_URL}/users/mci`,
    USER_UNLOCK: `${BASE_AUTH_URL}/user/unlock`,
    USER_UNLOCK_MAIL: `${BASE_AUTH_URL}/user/unlock/superadmin`,
    GET_SAVEDIMAGE: `${GET_IMAGE}/files/services/files/get-files`,
    PRO_ROLE_CHART: `${BASE_MENU_URL}/menu/product/rolechart`,
    FRONTPREVIEW_EDIT: `${BASE_BUSINESS_URL}/businessLicense/template`,
    FRONTPREVIEW_EDITUPDATE: `${BASE_BUSINESS_URL}/businessLicense/template`,
    DELETE_SUBSCRIPTION: `${BASE_SUBSCRIPTION_URL}/subscription/product/business/remove`,
    GET_PRINT: `${BASE_BUSINESS_URL}/loanTemplate`,
    POST_PRINT: `${BASE_BUSINESS_URL}/loanTemplate`,
    UPDATE_PRINT: `${BASE_BUSINESS_URL}/loanTemplate`
};
export const ACTION_TYPES = {
    SHOW_SNACKBAR: 'SHOW_SNACKBAR',
    HIDE_SNACKBAR: 'HIDE_SNACKBAR',
    SHOW_LOADER: 'SHOW_LOADER',
    HIDE_LOADER: 'HIDE_LOADER',
    AUTH: 'AUTH',
    SET_MENU_ITEMS: 'SET_MENU_ITEMS',
    CLEAR_MENU_ITEMS: 'CLEAR_MENU_ITEMS',
    SET_EXPIRY_ITEMS: 'SET_EXPIRY_ITEMS',
    CLEAR_EXPIRY_ITEMS: 'CLEAR_EXPIRY_ITEMS',
    SET_BUSINESS: 'SET_BUSINESS',
    CLEAR_BUSINESS: 'CLEAR_BUSINESS',
    SET_ORGANIZATION: 'SET_ORGANIZATION',
    CLEAR_ORGANIZATION: 'CLEAR_ORGANIZATION'
};
